import { render } from "./ImageUploadConfig.vue?vue&type=template&id=61604ee0&scoped=true&ts=true"
import script from "./ImageUploadConfig.vue?vue&type=script&lang=ts"
export * from "./ImageUploadConfig.vue?vue&type=script&lang=ts"

import "./ImageUploadConfig.vue?vue&type=style&index=0&id=61604ee0&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61604ee0"]])

export default __exports__